import { FormattedDate } from 'react-intl';
import { DateObservation } from '../types';
import { parseLocalDate } from '@/shared/i18n/dateUtils';

function compareDates(current: string | null, previous: string | null): 'improved' | 'worsened' | 'same' | 'unknown' {
  if (!current || !previous) return 'unknown';
  if (current < previous) return 'improved';
  if (current > previous) return 'worsened';
  return 'same';
}

const comparisonIndicators = {
  improved: { className: 'text-green-600', arrow: ' ↓' },
  worsened: { className: 'text-red-600', arrow: ' ↑' },
  same: { className: '', arrow: '' },
  unknown: { className: '', arrow: '' },
};

interface Props {
  observation: DateObservation | null;
  comparisonObservation?: DateObservation | null;
}

export default function DateCell({ observation, comparisonObservation }: Props) {
  if (!observation?.best_date) {
    return <span className="text-gray-400 italic">-</span>;
  }

  const comparison = comparisonObservation
    ? compareDates(observation.best_date, comparisonObservation.best_date)
    : 'unknown';

  const { className, arrow } = comparisonIndicators[comparison];

  return (
    <span className={className}>
      <FormattedDate
        value={parseLocalDate(observation.best_date)}
        year="numeric"
        month="2-digit"
        day="2-digit"
      />
      {arrow}
    </span>
  );
}
